<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="86" height="70" viewBox="0 0 86 70">
        <g id="Groupe_4" data-name="Groupe 4" transform="translate(-86 -965)">
            <circle id="Ellipse_12" data-name="Ellipse 12" cx="35" cy="35" r="35" transform="translate(92 965)" fill="#fff" />
            <text id="in" transform="translate(86 967)" fill="red" font-size="56" font-family="Roboto-Bold, Roboto" font-weight="700"><tspan x="19.895" y="53">in</tspan></text>
        </g>
    </svg>
</template>

<script>
export default {
    name: "Linkedin",
};
</script>

<style scoped></style>
